<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
        <router-link to="/quiz">
<img src="../../assets/strangert.png" /></router-link>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
